import { render, staticRenderFns } from "./ChampionTrophy.vue?vue&type=template&id=679b5cf6"
import script from "./ChampionTrophy.vue?vue&type=script&lang=js"
export * from "./ChampionTrophy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports